const URL = '/ordenes';

const state = {
  all: [],
  found: [],
  edited: {
    id: null,
    advertencia: null,
    chofer_id: null,
    domicilio_id: null,
    latitud: null,
    longitud: null,
    estado_id: null,
    observaciones: null,
    published_at: null,
  },
  selected: {
    id: null,
    advertencia: null,
    chofer_id: null,
    domicilio_id: null,
    latitud: null,
    longitud: null,
    estado_id: null,
    observaciones: null,
    published_at: null,
  },
  default: {
    id: null,
    advertencia: null,
    chofer_id: null,
    domicilio_id: null,
    latitud: null,
    longitud: null,
    estado_id: null,
    observaciones: null,
    published_at: null,
  },
  sort: {
    by: 'published_at',
    desc: 1,
    list: [
      {
        key: 'Fecha creado',
        value: 'created_at',
      },
      {
        key: 'Actualizaciones',
        value: 'updated_at',
      },
      {
        key: 'Fecha publicado',
        value: 'published_at',
      },
    ],
  },
  filters: {
    cliente: null,
    domicilio: null,
    estado_id: null,
    chofer_id: null,
    sinAsignar: null,
    zona_id: null,
    created_from: null,
    created_to: null,
    published_from: null,
    published_to: null,
    latitud_from: null,
    latitud_to: null,
    longitud_from: null,
    longitud_to: null,
  },
  // sort: {
  //   collection: [
  //     'Orden',
  //     'Cliente',
  //     'Zona',
  //     'Estado'
  //   ],
  //   by: null,
  //   desc: false,
  // },
  loading: false,
  headers: [
    {
      text: 'Publicado',
      value: 'published_at',
      align: 'center',
      width: '5%',
    },
    {
      text: 'Cliente',
      value: 'domicilio.cliente',
      align: 'center'
    },
    {
      text: 'Estado',
      value: 'estado',
      align: 'center'
    },
    {
      text: 'Chofer',
      value: 'chofer',
      align: 'center'
    },
    {
      text: 'Advertencia',
      value: 'advertencia',
      align: 'center'
    },
    {
      text: 'Actualizaciones',
      value: 'updated_at',
      align: 'center'
    }
  ],
  validations: {
    advertencia: [
      // v => !!v || 'Este campo es necesario',
    ],
    chofer_id: [
      // v => !!v || 'Este campo es necesario',
    ],
    domicilio_id: [
      v => !!v || 'Este campo es necesario',
    ],
    estado_id: [
      // v => !!v || 'Este campo es necesario',
    ],
    published_at: [
      // v => !!v || 'Este campo es necesario',
    ],
  },
  options: {},
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  anySelectedFilters (state) {
    return state.filters.zona_id || 
          state.filters.chofer_id ||
          state.filters.estado_id ||
          state.filters.domicilio ||
          state.filters.cliente ||
          state.filters.created_from ||
          state.filters.created_to ||
          state.filters.published_from ||
          state.filters.published_to ? false : true;
  },
  found (state) {
    return state.found
  },
  filters (state) {
    return state.filters
  },
  sort (state) {
    return state.sort
  },
  sortList (state) {
    return state.sort.list
  },
  edited (state) {
    return state.edited
  },
  selected (state) {
    return state.selected
  },
  rules (state) {
    return state.validations
  },
  headers (state) {
    return state.headers
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearFilters  ({ state, commit }) {
    commit('setFilters', {
      ...state.filters,
      cliente: null,
      domicilio: null,
      estado_id: null,
      chofer_id: null,
      sinAsignar: null,
      zona_id: null,
      created_from: null,
      created_to: null,
      published_from: null,
      published_to: null,
      latitud_from: null,
      latitud_to: null,
      longitud_from: null,
      longitud_to: null,
    })
  },
  onClearDomicilioId  ({ state, commit }) {
    commit('setEdited', {
      ...state.edited,
      domicilio_id: null,
    })
  },
  onResetEdited ({ state, commit }) {
    commit('setEdited', {
      ...state.edited,
      advertencia: null,
      domicilio_id: null,
      latitud: null,
      longitud: null,
      estado_id: null,
      observaciones: null,
      published_at: null,
    })
  },
  onFetch ({ state, commit, getters }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.get(URL, {
          params: {
            cliente: state.filters.cliente,
            domicilio: state.filters.domicilio,
            chofer_id: state.filters.chofer_id,
            created_from: state.filters.created_from,
            created_to: state.filters.created_to,
            estado_id: state.filters.estado_id,
            published_from: state.filters.published_from,
            published_to: state.filters.published_to,
            sinAsignar: state.filters.sinAsignar,
            zona_id: state.filters.zona_id,
            itemsPerPage: state.options.itemsPerPage,
            page: state.options.page,
            sortBy: state.sort.by,
            sortDesc: state.sort.desc,
          }
        })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onFind ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.get(URL + '/' + payload)
        .then(response => {
          commit('setEdited', response.data)
          commit('setSelected', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onLoad ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.get(URL + '/' + payload)
        .then(response => {
          commit('setSelected', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onPredeterminado ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.get(URL + '/' + payload)
        .then(response => {
          commit('setSelected', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onSearch ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.get(URL + '/busqueda/' + payload)
        .then(response => {
          commit('setFound', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onSave ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.post(URL, state.edited)
        .then(response => {
          const aux = {
            ...state.edited,
            id: response.data.id
          }
          commit('setEdited', aux)
          commit('ResponseHTTP/addSuccess', 'Se registro la informacion de la orden de distribucion nueva', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error: no se registro la informacion de la orden de distribucion nueva', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onUpdateEstado ({ state, commit }, orden_id, estado_id) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.post(URL + '/estados/' + orden_id, {
          estado_id: estado_id
        })
        .then(response => {
          const aux = {
            ...state.edited,
            id: response.data.id
          }
          commit('setEdited', aux)
          commit('ResponseHTTP/addSuccess', 'Se actualizo el estado de la orden de distribucion', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error: no se actualizo el estado de la orden de distribucion', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onUpdate ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.put(URL + '/' + state.edited.id, state.edited)
        .then(response => {
          commit('setSelected', state.edited)
          commit('ResponseHTTP/addSuccess', 'Se actualizo la informacion de la orden de distribucion', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error: no se actualizo la informacion de la orden de distribucion', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onDelete ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      window.axios.delete(URL + '/' + state.edited.id)
        .then(response => {
          commit('ResponseHTTP/addSuccess', 'Se elimino la informacion de la orden de distribucion', { root: true })
          commit('setEdited', state.default)
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error: no se elimino la informacion de la orden de distribucion', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
    // if (state.all && state.all.length > 0) alert('setAll')
  },
  setFound (state, payload) {
    state.found = payload
  },
  setEdited (state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters (state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setId (state, payload) {
    state.edited.id = payload
  },
  setDomicilioId (state, payload) {
    state.edited.domicilio_id = payload
  },
  setEstadoId (state, payload) {
    state.edited.estado_id = payload
  },
  setChoferId (state, payload) {
    state.edited.chofer_id = payload
  },
  setPublishedAt (state, payload) {
    state.edited.published_at = payload
  },
  setAdvertencia (state, payload) {
    state.edited.advertencia = payload
  },
  setObservaciones (state, payload) {
    state.edited.observaciones = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
  setFiltersCliente (state, payload) {
    window.sessionStorage.setItem('ordenes.cliente', payload)
    state.filters.cliente = payload
  },
  setFiltersDomicilio (state, payload) {
    state.filters.domicilio = payload
  },
  setFiltersEstadoId (state, payload) {
    window.sessionStorage.setItem('ordenes.estado_id', payload)
    state.filters.estado_id = payload
  },
  setFiltersChoferId (state, payload) {
    window.sessionStorage.setItem('ordenes.chofer_id', payload)
    state.filters.chofer_id = payload
  },
  setFiltersZonaId (state, payload) {
    window.sessionStorage.setItem('ordenes.zona_id', payload)
    state.filters.zona_id = payload
  },
  setFiltersCreatedFrom (state, payload) {
    window.sessionStorage.setItem('ordenes.created.to', payload)
    state.filters.created.from = payload
  },
  setFiltersCreatedTo (state, payload) {
    window.sessionStorage.setItem('ordenes.created.from', payload)
    state.filters.created.to = payload
  },
  setFiltersPublishedFrom (state, payload) {
    window.sessionStorage.setItem('ordenes.published.from', payload)
    state.filters.published.from = payload
  },
  setFiltersPublishedTo (state, payload) {
    window.sessionStorage.setItem('ordenes.published.to', payload)
    state.filters.published.to = payload
  },
  setFiltersSinAsignar (state, payload) {
    window.sessionStorage.setItem('ordenes.sin_asignar', payload)
    state.filters.sinAsignar = payload
  },
  setSortBy (state, payload) {
    state.sort.by = payload
  },
  setSortDesc (state, payload) {
    state.sort.desc = payload
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
